import React, { useRef } from 'react';
import PropTypes from 'prop-types';
/* eslint-disable import/no-unused-modules */
// eslint-disable-next-line no-unused-vars
import { translate } from 'helpers/translateHelper';
import { PopOutChart } from 'sharedComponents/Chart';
import { PopOutButton, ResetZoomButton, withLeftButtonGroup, withPopOutRow, withRightButtonGroup } from 'sharedComponents/Chart/headers';
import { InfoButtonWithOnlineHelp } from 'sharedComponents/InfoButtonWithOnlineHelp';
import IconCondition from 'svgIcons/MotionPortalIcons/IconCondition';
import { InfoMessage } from 'sharedComponents/InfoMessage';
import useChartConfig, { chartPlugins } from './useChartConfig';
import './styles.scss';
import useChartResize from 'sharedHooks/useChartResize';
import { onlineHelpLinks } from 'helpers/constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getEnvironmentStageSelector } from 'helpers/selectors';


const DriveStatusChartComponent = ({ trendDataLoadingStatus, selectedTrendsData, isZoomed, title, conditionStatus, assetDetails, actions }) => {

    const containerRef = useRef();
    const chartRef = useRef();
    const { i18n } = useTranslation();
    const environment = useSelector(getEnvironmentStageSelector);
    const languageCode = i18n.language;

    const resetServerZoom = () => {
        actions.reloadConditionInsights(assetDetails?.id);
    };

    const zoomIn = (from, to) => {
        actions.zoomInToSelectedTrendKpiData(assetDetails?.id, from, to);
    };

    const InfoTextElement = () => {
        return <div className='drive-events-info'>
            <h4 className='info-title'>
                {translate('ABB.Powertrain.Frontend.driveEventsTitle')}
            </h4>
            <p className='info-description'>
                {translate('ABB.Powertrain.Frontend.driveEventsDescription')}
            </p>
            <ul className='info-list'>
                <li>
                    <strong>{translate('ABB.Powertrain.Frontend.protectionEventsLabel')}:</strong> {translate('ABB.Powertrain.Frontend.protectionEventsDescription')}
                </li>
                <li>
                    <strong>{translate('ABB.Powertrain.Frontend.operationalEventsLabel')}:</strong> {translate('ABB.Powertrain.Frontend.operationalEventsDescription')}
                </li>
                <li>
                    <strong>{translate('ABB.Powertrain.Frontend.otherEventsLabel')}:</strong> {translate('ABB.Powertrain.Frontend.otherEventsDescription')}
                </li>
            </ul>
            <p className='info-status-description'>
                {translate('ABB.Powertrain.Frontend.conditionInsightsHourlyInfo')}
            </p>
            <p className='info-zoom-description'>
                {translate('ABB.Powertrain.Frontend.conditionInsightsZoomLessThan48HoursInfo')}
            </p>
            <p className='info-footer'>
                <a className='info-tooltip__link' rel='noreferrer' target='_blank' href={`${onlineHelpLinks[environment]}${languageCode}`} role='link' >
                    {translate('ABB.Powertrain.Frontend.assetOverviewTooltipLinkText')}
                </a>
            </p>
        </div>;
    };
    const ChartTitle = () => {
        return <div className={'drive-status-title'}>
            <span className='drive-status-icon'><IconCondition condition={conditionStatus}></IconCondition></span>
            <b>{title}</b>
            <InfoButtonWithOnlineHelp infoText={InfoTextElement()} withoutLink />
        </div>;
    };

    const MainChartHeader = withPopOutRow([
        withLeftButtonGroup([ChartTitle]),
        withRightButtonGroup([ResetZoomButton, PopOutButton])
    ]);

    /*const PopOutChartHeader = withPopOutRow([
        withLeftButtonGroup([ChartTitle]),
        withRightButtonGroup([ResetZoomButton, PopOutButton])
    ]);*/
    const cyclicLoadChartOptions = useChartConfig(selectedTrendsData, title, assetDetails);

    useChartResize(containerRef, chartRef);

    return (
        <div className={'cyclic-chart drive-status__chart'} ref={containerRef}>
            <PopOutChart
                hasKpi={true}
                renderNoKpi={
                    () => <InfoMessage
                        title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
                        text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />
                }
                loadingStatus={trendDataLoadingStatus}
                options={cyclicLoadChartOptions}
                modules={chartPlugins}
                container={'drivestatus-chart-pop-out'}
                zoomInServer={zoomIn}
                useLocalTimeZoom={true}
                resetServerZoom={resetServerZoom}
                isZoomed={isZoomed}
                setIsZoomed={actions?.setIsZoomed}
                zoomInToSelectedTrendKpiData={actions.zoomInToSelectedTrendKpiData}
                mainChartHeader={MainChartHeader}
                chartRef={chartRef}
            //popOutChartHeader={PopOutChartHeader}
            //popOutFooter={<Legend />}
            />
        </div>
    );
};
DriveStatusChartComponent.propTypes = {
    selectedTrendsData: PropTypes.array,
    trendDataLoadingStatus: PropTypes.string,
    isZoomed: PropTypes.bool,
    title: PropTypes.string,
    conditionStatus: PropTypes.number,
    assetDetails: PropTypes.object,
    actions: PropTypes.func
};
export default DriveStatusChartComponent;


